import { z } from "zod";

// Enum de roles (deve bater com o enum do banco de dados)
export const UserRole = z.enum(["ADMIN", "OPERATOR", "VIEWER"]);
export type UserRoleType = z.infer<typeof UserRole>;

// Schema para convite de usuário (área admin)
export const inviteUserSchema = z.object({
  email: z
    .string()
    .min(1, "Email é obrigatório")
    .email("Email inválido"),
  name: z
    .string()
    .min(2, "Nome deve ter no mínimo 2 caracteres")
    .max(255, "Nome deve ter no máximo 255 caracteres"),
  companyId: z
    .string()
    .uuid("ID da empresa inválido"),
  role: UserRole.optional().default("VIEWER"),
});

export type InviteUserInput = z.infer<typeof inviteUserSchema>;

// Schema para convite de usuário na área da empresa (sem companyId, pois é inferido)
export const companyInviteUserSchema = z.object({
  email: z
    .string()
    .min(1, "Email é obrigatório")
    .email("Email inválido"),
  name: z
    .string()
    .min(2, "Nome deve ter no mínimo 2 caracteres")
    .max(255, "Nome deve ter no máximo 255 caracteres"),
  role: UserRole,
});

export type CompanyInviteUserInput = z.infer<typeof companyInviteUserSchema>;

// Schema para atualização de role
export const updateUserRoleSchema = z.object({
  role: UserRole,
});

export type UpdateUserRoleInput = z.infer<typeof updateUserRoleSchema>;

// Schema para criação de usuário completo (com senha - uso interno)
export const createUserSchema = inviteUserSchema.extend({
  password: z
    .string()
    .min(6, "Senha deve ter no mínimo 6 caracteres")
    .max(100, "Senha deve ter no máximo 100 caracteres"),
});

export type CreateUserInput = z.infer<typeof createUserSchema>;

// Schema para resposta de usuário da API (para validar dados recebidos)
export const userResponseSchema = z.object({
  id: z.string().uuid(),
  email: z.string().email(),
  name: z.string(),
  companyId: z.string().uuid(),
  role: UserRole,
  isActive: z.boolean(),
  loginCount: z.number().int().nonnegative().optional(),
  createdAt: z.string().datetime().or(z.date()),
  updatedAt: z.string().datetime().or(z.date()),
  lastLoginAt: z.string().datetime().or(z.date()).nullable().optional(),
});

export type UserResponse = z.infer<typeof userResponseSchema>;

// Função helper para validar email
export function isValidEmail(email: string): boolean {
  return inviteUserSchema.shape.email.safeParse(email).success;
}

// Função helper para validar nome
export function isValidName(name: string): boolean {
  return inviteUserSchema.shape.name.safeParse(name).success;
}
